import { Box, Button, Paper } from '@mui/material';
import { styled } from '@mui/system';

import { DIALOG_SHADOW } from '../common/dialog/primitives';
import {
  BORDER, DIVIDER, MUTED, SANS_STACK, TEXT_DARK, TEXT_SECONDARY,
} from '../common/tokens';

const DIALOG_WIDTH = 360;
const DIALOG_MAX_HEIGHT = 620;

export const DialogPaper = styled(Paper)({
  width: DIALOG_WIDTH,
  maxHeight: DIALOG_MAX_HEIGHT,
  borderRadius: 8,
  boxShadow: DIALOG_SHADOW,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  fontFamily: SANS_STACK,
  backgroundColor: '#ffffff',
});

export const SectionLabel = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  padding: '8px 16px 4px',
  flexShrink: 0,
});

export const SectionLabelText = styled('span')({
  fontSize: 10.5,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.6px',
  color: MUTED,
});

export const SectionHint = styled('span')({
  fontSize: 10.5,
  fontWeight: 400,
  color: MUTED,
});

// The only part of the dialog that scrolls; everything else is pinned.
export const RowList = styled('ul')({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  margin: 0,
  padding: '4px 0',
  listStyle: 'none',
});

export const EmptyState = styled(Box)({
  padding: '20px 16px',
  fontSize: 13,
  color: TEXT_SECONDARY,
});

export const ShowMoreWrap = styled(Box)({
  padding: '8px 12px',
  borderTop: `1px solid ${DIVIDER}`,
  backgroundColor: '#fff',
  flexShrink: 0,
});

export const ShowMoreButton = styled(Button)({
  width: '100%',
  border: `1.5px solid ${BORDER}`,
  borderRadius: 8,
  padding: '8px 12px',
  background: '#fff',
  color: TEXT_DARK,
  fontSize: 13,
  fontWeight: 600,
  textTransform: 'none',
  fontFamily: SANS_STACK,
  gap: 8,
  '&:hover': { borderColor: TEXT_DARK, background: '#fff' },
  '&.Mui-disabled': { color: TEXT_SECONDARY, borderColor: BORDER },
});

export const FooterText = styled('span')({
  fontSize: 11,
  color: MUTED,
});

export const DoneButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: 13,
  fontWeight: 600,
  fontFamily: SANS_STACK,
  padding: '4px 16px',
  borderRadius: 8,
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  '&:hover': { backgroundColor: theme.palette.primary.dark },
}));
